import { render, staticRenderFns } from "./PT060LoginParts.vue?vue&type=template&id=3485dcc7&"
import script from "./PT060LoginParts.vue?vue&type=script&lang=js&"
export * from "./PT060LoginParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports